<ng-container *ngIf="navItem && navItem.path">
  <a
    *ngIf="!navItem.openExternal; else externalLink"
    [routerLink]="navItem.path"
    [class.top-link]="topLevel"
    [class.cg-disabled-link]="impersonator && !navItem.allowImpersonator"
    [class.cg-non-clickable]="impersonator && !navItem.allowImpersonator"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: false }"
    [attr.data-test]="
      dataTestAttribute ? dataTestAttribute : navItem.identifier
    "
    [cignaTrackClicks]="[
      'trackEventOther',
      navItem.title,
      topLevel ? 'ac-NV003-Primary Nav' : 'ac-NV004-Secondary Nav',
      { prop20: topLevel ? 'nav-top-menu' : 'nav-sub-menu' }
    ]"
  >
    {{ navItem.title }}
  </a>

  <ng-template #externalLink>
    <ng-container
      *ngIf="navItem.path.includes('resourceLibrary'); else externalDefault"
    >
      <a
        [class.top-link]="topLevel"
        [href]="
          navItem.path
            | resourceLink: { type: 'page', targetApp: navItem.targetApp }
            | async
        "
        target="resourcesWindow"
        [attr.data-test]="
          dataTestAttribute ? dataTestAttribute : navItem.identifier
        "
        [cignaTrackClicks]="[
          'trackEventOther',
          navItem.title,
          topLevel ? 'ac-NV003-Primary Nav' : 'ac-NV004-Secondary Nav',
          { prop20: topLevel ? 'nav-top-menu' : 'nav-sub-menu' }
        ]"
      >
        {{ navItem.title }}
      </a>
    </ng-container>
    <ng-template #externalDefault>
      <a
        [class.top-link]="topLevel"
        [class.cg-disabled-link]="impersonator && !navItem.allowImpersonator"
        [class.cg-non-clickable]="impersonator && !navItem.allowImpersonator"
        [href]="navItem.path"
        target="_blank"
        [attr.data-test]="
          dataTestAttribute ? dataTestAttribute : navItem.identifier
        "
        [cignaTrackClicks]="[
          'trackEventOther',
          navItem.title,
          topLevel ? 'ac-NV003-Primary Nav' : 'ac-NV004-Secondary Nav',
          { prop20: topLevel ? 'nav-top-menu' : 'nav-sub-menu' }
        ]"
      >
        {{ navItem.title }}
      </a>
    </ng-template>
  </ng-template>
</ng-container>
